import TemplateDiffViewModal from './TemplateDiffViewModal'

export default TemplateDiffViewModal
